/**
 * Created by andyosullivan on 04/04/2021.
 */
import React, { Component } from "react";
import "./Home.css";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
//import rightArrowBlack from '../../assets/images/rightArrowBlack.png';
import Card from "react-bootstrap/Card";
import { tv_details } from '../../assets/tv/tv_details';
import { movie_details } from '../../assets/movies/movie_details';
import { recipe_details } from '../../assets/recipes/recipe_details';

export default class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tvEpisodes: tv_details
                .filter(e => e.image_1 && e.image_1.image)
                .slice(0, 9)
                .map(e => ({ ...e, loadedImage: null })),

            movies: movie_details
                .filter(m => m.kind !== "top10" && m.image_1 && m.image_1.image)
                .slice(1, 10)
                .map(m => ({ ...m, loadedImage: null })),

            recipes: recipe_details
                .filter(r => r.image_1 && r.image_1.image)
                .slice(0, 5)
                .map(r => ({ ...r, loadedImage: null })),

            loadedImages: {
                heroImage: null,
                tvEpisodes: {},
                movies: {},
                recipes: {}
            },
            tv: {
                heroText: "The epic series returns, as good as before, with more dread than ever of what is coming.",
                title: "Last of Us - Series 2 Episode 1 Review",
                spoliers: true,
                darkTitle: false,
                summary: "The night is dark and full of terror",
                "name": "Last of Us - Series 2 Episode 1 Review",
                "tv": "last-of-us-series-2-episode-1-review",
                "subtitle": "The night is dark and full of terror",
                "reviewer": {name:"Andy O'Sullivan",twitter:"https://bsky.app/profile/andyosullivan.bsky.social"},
                "rating": 5,
                "wifereview": "",
                "kidsreview": "",
                "date": "14/Apr/25",
                "image_1": {image: "bella-ramsey_0.jpg", text: "", alt: ""},
            },
            movie: {
                tv: "top-15-movies-the-rest-of-2025",
                heroText: "Our first Top 10 post! OK, there are 15 movies here, but you get the picture - " +
                    "what's left to come in 2025. Can you guess No. 1 on our list?",
                allMovies: true,
                title: "The Top 15 Movies In The Rest Of 2025",
            "name": "The Top 15 Movies In The Rest Of 2025",
            "movie": "top-15-movies-the-rest-of-2025",
            "subtitle": "Can you guess no. 1?",
            "rating": 5,
            "image_1": {image:"top15movies.jpg", text:"",alt:""},
            "summary": "Can you guess no. 1?\"",
            "date": "19/Apr/25",
            "reviewer": {name:"Andy O'Sullivan",twitter:"https://bsky.app/profile/andyosullivan.bsky.social"},
            "short": false,
            },
            recipe: {
                name: "test",
                recipe: "test-recipe",
                date: "11/Jan/22",
                reviewer: "Andy O'Sullivan",
                wifereview: "test",
                kidsreview: "test",
                image_1: "dune001.jpg",
                image_2: "dune001.jpg",
                image_3: "dune001.jpg",
                image_4: "dune001.jpg",
                image_5: "dune001.jpg",
                image_6: "dune001.jpg",
                paragraph_1: "test",
                paragraph_2: "test",
                paragraph_3: "test",
                paragraph_5: "test ",
                paragraph_6: "test",
                paragraph_7: "",
                paragraph_8: "",
                paragraph_9: "",
                paragraph_10: "",
                ingredients: ["test", "test"]
            }
        };
    }

    componentDidMount() {
        this.deleteAllCookies();

        // Load hero image
        import("../../assets/images/" + this.state.movie.image_1.image)
            .then(image => {
                this.setState((prevState) => ({
                    loadedImages: { ...prevState.loadedImages, heroImage: image.default }
                }));
            })
            .catch(err => console.error("Error loading image:", err));

        // Load TV episode images
        this.state.tvEpisodes.forEach((item) => {
            import("../../assets/images/tv/" + item.image_1.image)
                .then((image) => {
                    this.setState((prevState) => ({
                        loadedImages: {
                            ...prevState.loadedImages,
                            tvEpisodes: { ...prevState.loadedImages.tvEpisodes, [item.name]: image.default }
                        }
                    }));
                })
                .catch(err => console.error("Error loading image:", err));
        });

        // Load movie images
        this.state.movies.forEach((item) => {
            import("../../assets/images/" + item.image_1.image)
                .then((image) => {
                    this.setState((prevState) => ({
                        loadedImages: {
                            ...prevState.loadedImages,
                            movies: { ...prevState.loadedImages.movies, [item.name]: image.default }
                        }
                    }));
                })
                .catch(err => console.error("Error loading image:", err));
        });

        // Load recipe images
        this.state.recipes.forEach((item) => {
            import("../../assets/images/" + item.image_1.image)
                .then((image) => {
                    this.setState((prevState) => ({
                        loadedImages: {
                            ...prevState.loadedImages,
                            recipes: { ...prevState.loadedImages.recipes, [item.name]: image.default }
                        }
                    }));
                })
                .catch(err => console.error("Error loading image:", err));
        });
    }

    deleteAllCookies() {
        var cookies = document.cookie.split(";");

        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            var eqPos = cookie.indexOf("=");
            var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
        }

        localStorage.clear();
        sessionStorage.clear();
    }

    render() {
        return (
            <div className="divmor">
                <Container>
                    <Row className="blurbRow">
                        <br />
                        <Row className="cardRow">
                            <Col sm={8}>
                                <div className="heroImageDiv"
                                     style={{
                                         backgroundImage: this.state.loadedImages.heroImage ? `url(${this.state.loadedImages.heroImage})` : 'none',
                                         backgroundSize: "cover",
                                     }}
                                >
                                </div>
                            </Col>
                            <Col sm={4}>
                                <p className="blurbTitle"><span className="titleSpan">{this.state.movie.title} </span><br />
                                    {this.state.movie.heroText} <a className="aboutLink" href={"/movies/" + this.state.movie.tv}><strong>Read the post</strong></a>.</p>
                            </Col>

                            <Col className="latestTV" sm={12}><h1 className="sectionTitle">Latest TV <a className="aboutLink" href="/tv/all">(or see all) </a></h1></Col>
                            {this.state.tvEpisodes.map((item) => (
                                <Col className="tvCol" sm={4} lg={4} key={item.name}>
                                    <div className="bgImageDiv" style={{
                                        backgroundImage: this.state.loadedImages.tvEpisodes[item.name] ? `url(${this.state.loadedImages.tvEpisodes[item.name]})` : 'none',
                                        backgroundSize: "cover"
                                    }}>
                                        <Card className="contentCard tv">
                                            <a className="cardLink" href={"/tv/" + item.tv}>
                                                <p className={!item.darkTitle ? "cardLinkText" : "cardLinkTextDark"}>{item.name}</p>
                                            </a>
                                        </Card>
                                    </div>
                                    <p className="tileText">{item.summary}</p>
                                </Col>
                            ))}
                            {/* ... */}
                            {/* Render Movies Section */}
                            <Col className="movieSection" sm={12}>
                                <h1 className="sectionTitle">Latest Movies <a className="aboutLink" href="/movies/all">(or see all)</a></h1>
                            </Col>
                            {this.state.movies.map((item) => (
                                <Col className="tvCol" sm={4} lg={4} key={item.name}>
                                    <div className="bgImageDiv" style={{
                                        backgroundImage: this.state.loadedImages.movies[item.name] ? `url(${this.state.loadedImages.movies[item.name]})` : 'none',
                                        backgroundSize: "cover"
                                    }}>
                                        <Card className="contentCard tv">
                                            <a className="cardLink" href={"/movies/" + item.movie}>
                                                <p className="cardLinkText">{item.name}</p>
                                            </a>
                                        </Card>
                                    </div>
                                    <p className="tileText">{item.summary}</p>
                                </Col>
                            ))}

                            {/* Render Recipes Section */}
                            <Col sm={12}>
                                <h1 className="sectionTitle">Latest Recipes <a className="aboutLink" href="/recipes/all">(or see all)</a></h1>
                            </Col>
                            {this.state.recipes.map((item) => (
                                <Col className="tvCol" sm={4} lg={4} key={item.name}>
                                    <div className="bgImageDiv" style={{
                                        backgroundImage: this.state.loadedImages.recipes[item.name] ? `url(${this.state.loadedImages.recipes[item.name]})` : 'none',
                                        backgroundSize: "cover"
                                    }}>
                                        <Card className="contentCard tv">
                                            <a className="cardLink" href={"/recipes/" + item.recipe}>
                                                <p className="cardLinkText">{item.name}</p>
                                            </a>
                                        </Card>
                                    </div>
                                </Col>
                            ))}

                        </Row>
                    </Row>
                </Container>
                <div className="footerAbout">
                    <a className="footerLinks" href="/">home</a>
                    <a className="footerLinks" href="/tv/all">tv</a>
                    <a className="footerLinks" href="/movies/all">movies</a>
                    <a className="footerLinks" href="/recipes/all">recipes</a>
                    <a className="footerLinks" href="/about/">about</a>
                </div>
            </div>
        );
    }
}
